import './CommentsContainer.scss';

import React, { FC } from 'react';

import { DocumentComment } from '../../../models/DocumentComment';
import RejectionComment from '../RejectionComment/RejectionComment';

interface CommentsContainerProps {
  rejectionComments: DocumentComment[];
}

const CommentsContainer: FC<CommentsContainerProps> = ({
  rejectionComments,
}) => (
  <div className="comments">
    <div className="comments-header">
      <h3>Comments</h3>
    </div>

    <div className="comments-container">
      {rejectionComments.map((comment) => <RejectionComment rejectionComment={comment} key={comment.id} />)}
    </div>
  </div>
);

export default CommentsContainer;
